import SuperJSON from "superjson";
import { ValueReference } from "../types/ValueReference";
import type { MetaVariableId } from "./metaVariable";

export default class MetaVariableReference extends ValueReference<MetaVariableId> {
  toString() {
    return this.id.toString();
  }

  static from(value: MetaVariableId) {
    return new MetaVariableReference(value);
  }
}

SuperJSON.registerClass(MetaVariableReference);

// The class name gets minified when building, but this can cause issues in our value references detection (see form version mapping)
// This is a workaround to keep a consistent class name.
Object.defineProperty(MetaVariableReference, "name", { value: "MetaVariableValueReference", configurable: true });
